module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-create-card-procedure.c5115d88.png";